import React, { useEffect, useMemo, useState } from 'react'
import Modal from 'react-modal'
import { swalError } from '../../common/components/Swaler'

const HandleStorageSupplierClientsModal = ({ isOpen, closeModal, suppliers, preselectedCompanies, updateSuppliers, t }) => {
  const [clientNumbers, setClientNumbers] = useState({})
  const [selectedCompanies, setSelectedCompanies] = useState([])

  useEffect(() => {
    if (preselectedCompanies && suppliers) {
      const newSelectedCompanies = preselectedCompanies.reduce((acc, company) => {
        const isDuplicate = acc.some((existingCompany) => existingCompany.value === company.value)

        if (!isDuplicate) {
          const isClientNumberMissing = !suppliers.some((supplier) => supplier.name === company.label && supplier.clientCompanies?.some((c) => c._id === company.value && c.clientNumber))

          if (isClientNumberMissing) {
            acc.push(company)
          }
        }

        return acc
      }, [])

      setSelectedCompanies(newSelectedCompanies)
    }
  }, [preselectedCompanies, suppliers])

  useEffect(() => {
    if (suppliers && preselectedCompanies) {
      const newClientNumbers = suppliers.reduce((acc, supplier) => {
        supplier.clientCompanies.forEach((cc) => {
          if (!acc[cc._id]) acc[cc._id] = {}

          acc[cc._id][supplier.name] = cc.clientNumber || '' // why, though
        })

        preselectedCompanies.forEach((c) => {
          if (!acc[c.value]) acc[c.value] = {}

          acc[c.value][supplier.name] = ''
        })

        return acc
      }, {})

      setClientNumbers(newClientNumbers)
    }
  }, [suppliers, preselectedCompanies])

  const submitNewClients = () => {
    const clientNumbersList = Object.values(clientNumbers)
    const missingClientNumber = clientNumbersList.find((n) => !n)
    if (missingClientNumber === '') return swalError(t('Oops!'), t('Missing field'))

    const clientNumberEntries = Object.entries(clientNumbers)

    const updatedSuppliers = {}

    for (const [companyId, suppliersValue] of clientNumberEntries) {
      for (const [supplierName, clientNumber] of Object.entries(suppliersValue)) {
        if (!clientNumber) return swalError(t('Oops!'), t('Missing field'))

        for (const [companyIdCheck, suppliersCheck] of clientNumberEntries) {
          for (const [supplierNameCheck, clientNumberCheck] of Object.entries(suppliersCheck)) {
            const isDuplicate = supplierName === supplierNameCheck && clientNumber === clientNumberCheck && companyId !== companyIdCheck
            if (isDuplicate) {
              return swalError(t('Oops!'), t('Duplicate client number'))
            }
          }
        }

        // after duplicate check is done, populate updatedsupplies
        if (!updatedSuppliers[supplierName]) updatedSuppliers[supplierName] = { name: supplierName }

        updatedSuppliers[supplierName] = {
          ...updatedSuppliers[supplierName],
          clientCompanies: [
            ...(updatedSuppliers[supplierName].clientCompanies || []),
            {
              _id: companyId,
              clientNumber,
            },
          ],
        }
      }
    }

    updateSuppliers(Object.values(updatedSuppliers))

    setSelectedCompanies([])
  }

  const rows = useMemo(() => suppliers?.reduce((acc, s) => acc.concat(...(s.clientCompanies || []).map((c) => ({ supplierName: s.name, ...c }))), []), [suppliers])

  if (!rows) return null

  return (
    <Modal isOpen={isOpen} onRequestClose={closeModal} style={{ content: { background: '#F1F5F6' } }} contentLabel="Handle Storage Supplier Clients Modal">
      <div>
        <div className="flex justify-end">
          <button style={{ backgroundColor: 'grey', margin: 0, height: 30, fontSize: 16, width: 60 }} onClick={closeModal}>
            {t('Close')}
          </button>
        </div>
        <div>
          <h3>Add customer</h3>
          <p>The customer you have appointed to the user is missing a customer number. Please fill in the form below.</p>
        </div>
        {selectedCompanies.map((selectedCompany) => (
          <div key={selectedCompany.value}>
            {suppliers.map((supplier, idx) => (
              <div key={`${selectedCompany.value}-${supplier.name}`} className="flex">
                <div style={{ flex: 1, padding: 20 }}>
                  {idx === 0 && (
                    <div
                      style={{
                        flex: 1,
                        padding: 8,
                        border: '1px solid lightgrey',
                        borderRadius: 3,
                        background: '#fff',
                      }}
                    >
                      {selectedCompany.label}
                    </div>
                  )}
                </div>
                <div style={{ flex: 1, padding: 20 }}>
                  <input
                    type="text"
                    style={{
                      padding: 8,
                      width: '100%',
                      border: '1px solid lightgrey',
                      borderRadius: 3,
                    }}
                    placeholder="Customer number"
                    value={clientNumbers[selectedCompany.value]?.[supplier.name] || ''}
                    onChange={(e) =>
                      setClientNumbers({
                        ...clientNumbers,
                        [selectedCompany.value]: {
                          ...clientNumbers[selectedCompany.value],
                          [supplier.name]: e.target.value,
                        },
                      })
                    }
                  />
                </div>
                <div style={{ padding: 20, flex: 1 }}>
                  <div
                    style={{
                      padding: 8,
                      border: '1px solid lightgrey',
                      borderRadius: 3,
                      background: '#fff',
                    }}
                  >
                    {supplier.name}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}

        <div style={{ display: 'flex', padding: 20, justifyContent: 'center' }}>
          <button className="submitButton" style={{ width: 200, padding: '10px 0px', display: 'flex' }} onClick={submitNewClients}>
            <span style={{ marginRight: '33%', marginLeft: '10%', alignSelf: 'flex-start' }}>+</span>
            <span>Add</span>
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default HandleStorageSupplierClientsModal
